/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchUsers ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('https://api.conferences-list.uz/api/v1/admin/users', {
          params: { filterStatus: payload.filter, page: payload.page }
        })
        .then(response => {
          const resData = response.data.data
          commit('SET_USERS', resData.data)
          commit('SET_META', {
            current_page: resData.current_page,
            first_page_url: resData.first_page_url,
            from: resData.from,
            last_page: resData.last_page,
            last_page_url: resData.last_page_url,
            next_page_url: resData.next_page_url,
            path: resData.path,
            per_page: resData.per_page,
            prev_page_url: resData.prev_page_url,
            to: resData.to,
            total: resData.total
          })
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchUser (context, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`https://api.conferences-list.uz/api/v1/admin/users/${userId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  removeRecord ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`https://api.conferences-list.uz/api/v1/admin/users/${userId}`)
        .then(response => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
